export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 6.3b9083a2.jpg";